import { render, staticRenderFns } from "./RetailerSearchBox.vue?vue&type=template&id=66229787&"
import script from "./RetailerSearchBox.vue?vue&type=script&lang=ts&"
export * from "./RetailerSearchBox.vue?vue&type=script&lang=ts&"
import style0 from "./RetailerSearchBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports